import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  error: null,
  updateUser: undefined,
};

export const userSlice = createSlice({
  name: 'userInfo',
  initialState: initialState,
  reducers: {
    catchError: (state, action) => {
      state.error = action.payload.desc;
      state.loading = false;
    },
    startCall: (state) => {
      state.error = null;
      state.loading = true;
    },
    userUpdated: (state, action) => {
      state.error = null;
      state.loading = false;
      state.userUpdated = action.payload.updateUser;
      console.log('userUpdated', state, action);
      return state;
    },
  },
});
